module.exports = __webpack_public_path__ + "img/service19.9ffdf815.svg";